<template>
  <div class="agent">
    <template v-if="from != 'introDetail'">
      <div id="block"></div>
      <Header />
      <img src="../../../assets/coursePage/agent/banner.png" alt="AI开发智能体" />
    </template>
    <img src="../../../assets/coursePage/agent/two.png" alt="AI开发智能体 岗位缺口" />
    <img src="../../../assets/coursePage/agent/three.png" alt="AI开发智能体 职业发展" />
    <img src="../../../assets/coursePage/agent/four.png" alt="AI开发智能体 职业发展" />
    <img src="../../../assets/coursePage/agent/five.png" alt="AI开发智能体 职业发展" />
    <img src="../../../assets/coursePage/agent/six.png" alt="AI开发智能体 职业发展" />
    <project />
    <Box7 />
    <img src="../../../assets/coursePage/agent/nine.png" />
    <pageRightFloat pageName="nau-北亚利桑那大学" />
    <Footer />
  </div>
</template>

<script>
import Box7 from "./Box7.vue";
import project from "./Box7-1.vue";
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
    Box7,
    project,
    pageRightFloat,
    Header,
    Footer,

  },
  data() {
    return {
      flag: false,
      src: "",
      from: ''
    };
  },
  mounted() {
    this.from = this.getQueryString("from")
    var header = document.getElementById('eleTop');
    var headerOriginalPos = header.offsetTop * 3.5 - 40; // 获取元素原来的位置
    var box5Height = document.getElementById('box5').offsetHeight + 180;
    window.addEventListener('scroll', function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(headerOriginalPos,scrollTop,'吸顶')
      if (scrollTop > headerOriginalPos && scrollTop < box5Height + headerOriginalPos) {
        header.setAttribute("class", "top topFixed");
      } else {
        header.setAttribute("class", "top");
      }
    })
  },

  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },

    close() {
      this.src = "";
      this.flag = false;
    },
    zixun(name) {
      zhuge.track("H5_AI训练师专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.agent {
  width: 100%;

  img {
    width: 100%;
    display: block;
  }
}

/deep/ .swiper-pagination-bullet {
  opacity: 1;
}

#block {
  width: 100%;
  height: 88px;
}

.show {
  width: 222px !important;

  .video-text {
    width: 100% !important;
  }
}

.video-float {
  transition: all 0.5s;
  position: fixed;
  right: 0;
  top: 136px;
  width: 10px;
  height: 64px;
  background: #ffffff linear-gradient(142deg,
      rgba(214, 222, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.5) 100%);
  box-shadow: 0px 4px 24px -8px rgba(94, 123, 218, 0.4);
  border-radius: 200px 0px 0px 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 29;

  .play-btn {
    background: url("../../../assets/coursePage/java/javaPlay.png");
    width: 36px;
    height: 36px;
    background-size: cover;
    display: inline-block;
    flex-shrink: 0;
    margin: 0px 12px 0px 16px;
  }

  .video-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #273f6e;
    white-space: nowrap;

    width: 0;
    overflow: hidden;
  }
}
</style>
